export default "__VITE_ASSET__B8ijJ4C0__"